import { Button, Skeleton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCreditsAndPlans } from './context';

export default function PlanDetails() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { downMd, planName, planNameLoading, isThirdPartyMerchant } = useCreditsAndPlans()

    return (
        <Stack spacing={2}>
            {
                planNameLoading ?
                    <Skeleton variant="text" width={100} height={20} />
                    :
                    <Typography variant={downMd ? "h4" : "body1"} fontWeight="bold">
                        {planName}
                    </Typography>
            }
            {
                !isThirdPartyMerchant &&
                <Button variant="contained" sx={{ textTransform: "none" }} onClick={() => navigate("/merchant/account/plans")}>
                    {t("Upgrade Plan")}
                </Button>
            }
        </Stack>
    )
}
